import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  color?: string
  size?: number
}

const AssessmentsAndResearchModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken(
    'colors',
    ['primary.200', 'primary.300', 'primary.400', 'primary.500', 'primary.600', 'primary.700', 'primary.900', 'white']
  )

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 742.38 641.87">
        <g id="Camada_2" data-name="Camada 2">
          <g id="Layer_1" data-name="Layer 1">
            <g id="Avaliações_e_Pesquisas" data-name="Avaliações e Pesquisas">
              <g id="background">
                <g id="group200">
                  <path
                    d="M149.17,412c7.28,88.61,61.54,170.35,149.33,207.44C415.78,669,553.63,619,613.67,505.05l1.19-2.28c16.41-31.9,40.12-59.17,68.55-80.91a150.39,150.39,0,0,0,47.2-61.16c31.31-74.1-2-160.51-74.39-193.44-28.05-12.76-98.42-17.44-152.43-20-36.42-1.74-69.16-21.79-88-53.07a194.32,194.32,0,0,0-96.46-81C225.84-23.28,118.14,18.48,72,108.82c-43,84.24-21,183.25,46,241A91.74,91.74,0,0,1,149.17,412Z"
                    fill={fillColor200}
                    opacity="0.25"
                  />
                </g>
                <g id="group400">
                  <path
                    d="M615.07,163.85c6.52-45.63-11.5-93.21-51.6-122.07C509.89,3.23,434.44,12.63,391,63.29l-.86,1a125.08,125.08,0,0,1-44,33,77.94,77.94,0,0,0-30.91,25.48c-24.36,33.85-17.48,81.37,15.33,106.36,12.71,9.68,47.75,20.15,74.75,27.68,18.21,5.07,30.83,13.43,36.76,31.41,6.75,20.45,37.05,44.72,64.74,43.41,51.94-2.45,61.11-14.06,95.93-53.47,15.62-17.68,41.79-33.17,14.61-70.09C610,198.09,613.29,176.25,615.07,163.85Z"
                    fill={fillColor400}
                    opacity="0.2"
                  />
                  <path
                    d="M419.6,437.51c-14.78,43.66-5.8,93.73,28.33,129.46,45.59,47.73,121.48,52.34,173.51,10.51l1-.85a125.1,125.1,0,0,1,49.28-24.37,78,78,0,0,0,35.06-19.38c30.16-28.81,32.11-76.78,4.44-107.36-10.72-11.85-43.23-28.58-68.4-40.93-17-8.33-27.83-18.86-30.37-37.63-2.88-21.34-28.22-50.75-55.67-54.55-51.51-7.12-62.65,2.61-104.11,35-18.6,14.51-47.17,24.94-27.23,66.22C430.89,404.78,423.62,425.64,419.6,437.51Z"
                    fill={fillColor400}
                    opacity="0.2"
                  />
                  <path
                    d="M65.82,333.65C25.58,356.14-1.32,399.31.05,448.7c1.83,66,55.05,120.28,121.7,124.12l1.34.07a125,125,0,0,1,52.9,15A78,78,0,0,0,215,597c41.69-1.16,75.3-35.45,75.27-76.68,0-16-12.92-50.19-23.31-76.23-7-17.56-8-32.65,2.69-48.28,12.16-17.77,13.09-56.58-4.74-77.8-33.45-39.82-48.24-40.06-100.69-43.85C140.69,272.42,112.5,261,99.63,305,96.14,316.93,76.76,327.55,65.82,333.65Z"
                    fill={fillColor400}
                    opacity="0.2"
                  />
                </g>
                <g id="group600">
                  <path
                    d="M607.79,143.51s43,73.79-46,154.23c-77.9,70.39,87.72,115.05,60.93,180.54-36.52,89.29-99.46,132.5-164.54,134.07-119.49,2.88-68.65-76-108.77-101.16-74.62-46.86-52.11,7.55-146.66-19.36C112.46,466.14,173.18,388,123.26,360.58c-72.75-39.88-96-39.75-108.5-104.67C8,221,67.27,159.57,151,111.11c101.89-59,49-77.18,157-77.18,60,0,46.36-.12,74.66,12.83C445.94,75.72,564.64,69.4,607.79,143.51Z"
                    fill={fillColor600}
                  />
                  <path
                    d="M660,368.09c8.76,5.85,19,6.2,26.64,2a10.7,10.7,0,0,1,11.54,1.08l.16.11c4.82,3.46,11.18,3.47,15.17,0,5.31-4.58,4.75-13.06-.91-18.26a14.32,14.32,0,0,0-5.78-3.25,20,20,0,0,1-12.12-10.51A29.64,29.64,0,0,0,683.3,327c-12.65-7.55-27.92-4.08-33.88,7.79C643.9,345.78,648.54,360.47,660,368.09Z"
                    fill={fillColor600}
                  />
                  <path
                    d="M84.08,364.22c11.7,13.1,4.31,38.78-8.79,50.48s-27,5-38.67-8.12-21.26-45.21-8.15-56.9S72.38,351.11,84.08,364.22Z"
                    fill={fillColor600}
                  />
                  <path
                    d="M358,609.42a18.64,18.64,0,0,1-25,27.63c-7.63-6.91-22.69-18-15.78-25.61S350.39,602.51,358,609.42Z"
                    fill={fillColor600}
                  />
                </g>
              </g>
              <rect
                x="158.35"
                y="76.06"
                width="466.87"
                height="466.87"
                rx="129.69"
                stroke={strokeColor900}
                strokeWidth={strokenWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
                fill={fillBG}
              />
              <path
                d="M521.47,439.18,461,378.75"
                stroke={strokeColor900}
                strokeWidth={strokenWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
              <path
                d="M480.23,223.38,378,325.06,336.28,283.3"
                stroke={strokeColor900}
                strokeWidth={strokenWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
              <path
                d="M494.24,308.46H494A117.72,117.72,0,0,1,365.59,414c-64.85-6.48-112-63.8-105.83-128.39A117.35,117.35,0,0,1,387.89,179.81a112.3,112.3,0,0,1,29.05,6.48"
                stroke={strokeColor900}
                strokeWidth={strokenWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
            </g>
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(AssessmentsAndResearchModuleBrand)
